import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Collapse } from "react-bootstrap";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../../../constants/PublicVariables";
import { SURVEY_COMMENT_MAX_LENGTH, SURVEY_FEEDBACK, SURVEY_TYPE } from "../../../../constants/SurveyConstants";
import { LogFirebase } from "../../../../services/firestore";
import googleEvent from "../../../../services/googleEvent";
import { surveyRedirection } from "../../../../shared/utility";
import { putSurveyComment, putSurveyRating } from "../../../../actions/surveyAction";

const Survey = () => {
    const dispatch = useDispatch();

    const { putSurveyRatingData, putSurveyRatingError, putSurveyCommentData, putSurveyCommentError } = useSelector((state) => state.survey);

    const [formFeedbackText, setFormFeedbackText] = useState("");
    const [formFeedbackSubmitted, setFormFeedbackSubmitted] = useState(true);
    const [isFeedbackFormOpen, setIsFeedbackFormOpen] = useState(false);
    const feedbackFormRef = useRef();

    const localisedValues = useLanguageChange();

    useEffect(() => {
        removeActiveClassFromButtons();
    }, []);

    useEffect(() => {
        if (putSurveyRatingData) {
            LogFirebase("Survey", "surveyRating", "sent");
        }
    }, [putSurveyRatingData]);

    useEffect(() => {
        if (putSurveyRatingError) {
            LogFirebase("Survey", "surveyError", putSurveyRatingError);
        }
    }, [putSurveyRatingError]);

    useEffect(() => {
        if (putSurveyCommentData) {
            LogFirebase("Survey", "surveyComment", "sent");
        }
    }, [putSurveyCommentData]);

    useEffect(() => {
        if (putSurveyCommentError) {
            setFormFeedbackSubmitted(false);
            LogFirebase("Survey", "surveyError", putSurveyCommentError);
        }
    }, [putSurveyCommentError]);

    const removeActiveClassFromButtons = () => {
        document.getElementById("thumb-up-button")?.classList?.remove("active");
        document.getElementById("thumb-down-button")?.classList?.remove("active");
    };

    const submitRatting = (ratting) => {
        LogFirebase("Survey", "surveyThumb", ratting === SURVEY_FEEDBACK.LIKEUP ? "Up" : "Down");
        googleEvent.logEvent(ratting === SURVEY_FEEDBACK.LIKEUP ? "THUMBS_UP_PRESSED" : "THUMBS_DOWN_PRESSED");

        removeActiveClassFromButtons();
        document.getElementById(ratting === SURVEY_FEEDBACK.LIKEUP ? "thumb-up-button" : "thumb-down-button")?.classList?.add("active");

        if (
            GLOBAL_MEETING_DATA.survey?.surveyType === SURVEY_TYPE.SURVEYMONKEY ||
            GLOBAL_MEETING_DATA.survey?.surveyType === SURVEY_TYPE.CUSTOMLINK
        ) {
            surveyRedirection();
        } else {
            setIsFeedbackFormOpen(true);
            dispatch(putSurveyRating(ratting));
        }
    };

    const formFeebackTextChangeHandler = (e) => {
        const val = e.target.value;
        setFormFeedbackText(val);
        setFormFeedbackSubmitted(false);
    };

    const submitComment = () => {
        dispatch(putSurveyComment(formFeedbackText?.trim()));
        setFormFeedbackSubmitted(true);
    };

    return (
        <div className='quality-feedback'>
            <div className='quality-feedback-in'>
                <div className='feedback-title'>
                    <div className='feedback-title-in'>{localisedValues?.overall_experience}</div>
                </div>
                <div className='quality-feedback-button-row'>
                    <div className='button'>
                        <button
                            id='thumb-up-button'
                            className='btn feedback-btn'
                            data-testid='survey-button-like-up'
                            aria-controls='feedback-form'
                            aria-expanded={isFeedbackFormOpen}
                            onClick={() => submitRatting(SURVEY_FEEDBACK.LIKEUP)}
                        >
                            <span className='for-icon icon-thumbs-up'></span>
                            <span className='for-text'>{localisedValues?.it_was_great_lable}</span>
                        </button>
                    </div>
                    <div className='button'>
                        <button
                            id='thumb-down-button'
                            className='btn feedback-btn'
                            data-testid='survey-button-like-down'
                            aria-controls='feedback-form'
                            aria-expanded={isFeedbackFormOpen}
                            onClick={() => submitRatting(SURVEY_FEEDBACK.LIKEDOWN)}
                        >
                            <span className='for-icon icon-thumbs-down'></span>
                            <span className='for-text'>{localisedValues?.not_so_great_lable}</span>
                        </button>
                    </div>
                </div>
                <Collapse in={isFeedbackFormOpen}>
                    <div id='feedback-form' ref={feedbackFormRef} className='quality-feedback-form'>
                        <div className='quality-feedback-form-in'>
                            <div className='quality-feedback-form-box'>
                                <div className='swme-form-group'>
                                    <div className='inputchar-count'>{SURVEY_COMMENT_MAX_LENGTH - formFeedbackText.length}</div>
                                    <div className='swme-form-group-in'>
                                        <textarea
                                            className='swme-form-control custom-scroll'
                                            placeholder={localisedValues?.leave_comment}
                                            value={formFeedbackText}
                                            maxLength={SURVEY_COMMENT_MAX_LENGTH}
                                            data-testid='survey-feedback'
                                            onChange={formFeebackTextChangeHandler}
                                            style={{ fontSize: PublicVariables.isIOSDevice ? "16px" : "" }}
                                        />
                                        <span className='for-bg'></span>
                                        <span className='for-border'></span>
                                    </div>
                                </div>
                                {formFeedbackText?.trim()?.length > 0 && (
                                    <div className='button feedback-send-button'>
                                        {!formFeedbackSubmitted && (
                                            <button
                                                className='btn btn-primary btn-sm2'
                                                id='buttonSend'
                                                data-testid='button-send'
                                                onClick={() => submitComment()}
                                            >
                                                {localisedValues?.send}
                                            </button>
                                        )}
                                        {formFeedbackSubmitted && (
                                            <button className='btn btn-primary btn-sm2' id='buttonThanks' data-testid='button-thanks' disabled>
                                                {localisedValues?.thanks}
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Collapse>
            </div>
        </div>
    );
};

export default Survey;
